export default "__VITE_ASSET__BcMJ9rS8__"